import { Injectable } from '@angular/core';
import { MessageService } from '@sla-ng/core';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import { ICostingLevel } from '../../../models/costing-level.model';
import { CostingLevelResource } from '../../../resources/costing-level.resource';
import { ICostingLevelsState } from './costing-levels-state.model';

let _state: ICostingLevelsState = {
    isLoading: false,
};

@Injectable({
    providedIn: 'root',
})
export class CostingLevelsFacade {

    protected store$: BehaviorSubject<ICostingLevelsState> = new BehaviorSubject<ICostingLevelsState>(_state);

    constructor(private myCostingLevelResource: CostingLevelResource,
                private myMessageService: MessageService) {
    }

    public subState(): Observable<ICostingLevelsState> {
        return this.store$.asObservable();
    }

    public getStateSnapshot(): ICostingLevelsState {
        return this.store$.value;
    }

    public async deleteCostingLevel(costingLevelId: number): Promise<void> {
        this.setIsloading(true);
        try {
            await firstValueFrom(this.myCostingLevelResource.deleteCostingLevel(costingLevelId));
            this.myMessageService.successTrans('app.actions.feedback.saved', 'app.page.costing-level.actions.deleted.label');
        } catch (e) {
            console.error(e);
        }
        this.setIsloading(false);
    }

    public async addKalkstufe(costingLevel: ICostingLevel): Promise<void> {
        this.setIsloading(true);
        const createdCostingLevel: ICostingLevel = await this.myCostingLevelResource.addCostingLevel(costingLevel).toPromise().catch(() => null);
        if (createdCostingLevel !== null) {
            this.myMessageService.successTrans('app.actions.feedback.saved', 'app.page.costing-level.actions.added.label');
        }
        this.setIsloading(false);
    }

    public async editKalkstufe(costingLevel: ICostingLevel): Promise<void> {
        this.setIsloading(true);
        const editedCostingLevel: ICostingLevel = await this.myCostingLevelResource.updateCostingLevel(costingLevel).toPromise().catch(() => null);
        if (editedCostingLevel !== null) {
            this.myMessageService.successTrans('app.actions.feedback.saved', 'app.page.costing-level.actions.edited.label');
        }
        this.setIsloading(false);

    }


    private updateState(state: ICostingLevelsState): void {
        this.store$.next(_state = state);
    }

    private setIsloading(isLoading: boolean): void {
        this.updateState({ ..._state, isLoading });
    }
}
